module.exports = __webpack_public_path__ + "img/growcify-dashboard-banner-1.7c51afde.png";